/**
 * How a module is rendered in the portal application.
 * Each type represents the way a module is rendered,
 * see the is a corresponding route path for each type.
 */
export enum ModuleTypes {
    welcome = 'welcome',
    landing = 'landing',
    content = 'content'
}
